export const mediaPhotoStateSelector = state => state.stickers.mediaPhoto;